<template>
  <div class="addressContainer">
    <md-tabs>
      <md-tab-pane class="content" name="0" :label="items[0].label">
        <div v-if="list.length > 0">
          <div v-for="(item, index) in list" :key="index" class="addreslist">
            <div class="addresname" @click="getaddres(item)">
              <p>{{ item.name }} ,{{ item.mobile }}</p>
              <p style="margin-top: 0.15rem">{{ item.concatAddress }}</p>
            </div>
            <div class="addresopeartion">
              <div v-if="!code">
                <div class="default" v-if="item.isDefault == 1">
                  <md-icon name="success" size="md" color="#ff5257"></md-icon>
                  <span style="margin-left: 0.1rem">已設為默認</span>
                </div>
                <div class="default" v-else @click="setdefaultadd(item)">
                  <md-icon name="check" size="md"></md-icon>
                  <span style="margin-left: 0.1rem">設為默認</span>
                </div>
              </div>
              <div v-else>
                <div class="default" v-if="item.id == id">
                  <md-icon name="success" size="md" color="#ff5257"></md-icon>
                  <span style="margin-left: 0.1rem">當前使用地址</span>
                </div>
                <div class="default" v-else @click="user(item)">
                  <md-icon name="check" size="md"></md-icon>
                  <span style="margin-left: 0.1rem">使用該地址</span>
                </div>
              </div>
              <div class="opeartion">
                <md-button
                  type="link"
                  style="color: #888888"
                  @click="deleteaddres(item)"
                  >删除</md-button
                >
                <md-button type="link" @click="editaddres(item.id)"
                  >修改</md-button
                >
              </div>
            </div>
          </div>
        </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </md-tab-pane>
      <md-tab-pane class="content" name="1" :label="items[1].label">
        <div v-if="listtwo.length > 0">
          <div v-for="(item, index) in listtwo" :key="index" class="addreslist">
            <div class="addresname" @click="getaddres(item)">
              <p>{{ item.name }} ,{{ item.mobile }}</p>
              <p style="margin-top: 0.15rem">
                {{ item.countryName }} {{ item.provinceName }}
                {{ item.cityName }} {{ item.areaName }} {{ item.address }}
              </p>
            </div>
            <div class="addresopeartion">
              <div class="opeartion">
                <md-button
                  type="link"
                  style="color: #888888"
                  @click="deleteaddres(item)"
                  >删除</md-button
                >
              </div>
            </div>
          </div>
        </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </md-tab-pane>
    </md-tabs>
    <md-button type="warning" style="position: fixed;bottom: 0" @click="addres"
      >新增地址</md-button
    >
  </div>
</template>

<script>
import { Button, Icon, Dialog, Toast, Tabs, TabPane } from "mand-mobile";
import NothModal from "../Modal/NothModal";
import eventBus from "../../until/eventBus";
export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  name: "address",
  data() {
    return {
      list: [],
      listtwo: [],
      items: [
        { name: 0, label: "住宅地址" },
        { name: 1, label: "自提点" }
      ],
      code: true,
      id: ""
    };
  },
  activated() {
    this.$route.query.index != undefined
      ? (this.code = true)
      : (this.code = false);
    this.$route.query.addresid != undefined
      ? (this.id = this.$route.query.addresid)
      : (this.id = "");
    Toast.loading("請稍等...");
    this.getAddreslits();
    this.getmallList();
  },
  methods: {
    getmallList() {
      this.http
        .APIASK(this.ports.mallList, "get")
        .then(res => {
          this.listtwo = res;
          Toast.hide();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getAddreslits() {
      this.http
        .APIASK(this.ports.addresslist, "get")
        .then(res => {
          this.list = res;
          Toast.hide();
        })
        .catch(err => {
          Toast.hide();
        });
    },
    getaddres(item) {
      if (this.code) {
        eventBus.$emit("useraddres", item);
        this.$router.go(-1);
      } else {
        Toast.loading("請稍等...");
        this.http
          .APIASK(this.ports.setDefault, "post", item)
          .then(res => {
            this.getAddreslits();
            Toast.succeed("設定成功");
          })
          .catch(err => {
            Toast.hide();
          });
      }
    },
    deleteaddres(item) {
      Dialog.confirm({
        content: "確定要删除該地址嗎",
        confirmText: "確定",
        onConfirm: () => this.delet(item)
      });
    },
    user(item) {
      localStorage.setItem("chageaderes", "1");
      console.log(localStorage.getItem("chageaderes"));
      eventBus.$emit("useraddres", item);
      this.$router.go(-1);
    },
    delet(item) {
      Toast.loading("請稍等...");
      this.http
        .APIASK(this.ports.addressdeleted, "post", item)
        .then(res => {
          this.getAddreslits();
          this.getmallList();
          Toast.succeed("删除成功");
        })
        .catch(err => {
          Toast.hide();
        });
    },
    addres() {
      this.$router.push({ name: "AddAddres", query: { name: "新增海外地址" } });
    },
    editaddres(id) {
      this.$router.push({
        name: "AddAddres",
        query: { name: "修改海外地址", id: id }
      });
    },
    setdefaultadd(item) {
      Toast.loading("請稍等...");
      this.http
        .APIASK(this.ports.setDefault, "post", item)
        .then(res => {
          this.getAddreslits();
          Toast.succeed("設定成功");
        })
        .catch(err => {
          Toast.hide();
        });
    }
  }
};
</script>

<style lang="less">
.addressContainer {
  .md-tab-bar {
    position: static;
    height: 1rem;
  }
  .addreslist {
    width: 100%;
    background-color: white;
    margin-bottom: 0.2rem;
    .addresname {
      width: 94%;
      margin-left: 3%;
      border-bottom: 0.02rem solid #e2e4ea;
      font-size: 0.32rem;
      text-align: left;
      padding: 0.2rem 0;
    }
    .addresopeartion {
      display: flex;
      justify-content: space-between;
      height: 0.8rem;
      align-items: center;
      width: 94%;
      margin-left: 3%;
      .default {
        display: flex;
        height: 100%;
        align-items: center;
        font-size: 0.3rem;
      }
      .opeartion {
        display: flex;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        width: 30%;
      }
    }
  }
}
</style>
